import { ClientNode } from '../../../model/client-model/client-node';
import { CustomTargetModelData } from '../../../model/custom-model/custom-target-model-data';
import { holdsCustomModel } from './holds-custom-model';

export function holdsActiveCustomModel(
  node: ClientNode
): node is ClientNode & { nodeProperties: { customTargetModelData: CustomTargetModelData } } {
  return holdsCustomModel(node) && !!node.nodeProperties?.customTargetModelData;
}
